// src/ApkDetectionWrapper.jsx
import { useEffect, useState } from "react";
import "./ApkDetectionWrapper.css";

function isInsideApk() {
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.includes("wv") ||
    ua.includes("webview") ||
    ua.includes("android webview") ||
    ua.includes("median") ||
    ua.includes("gradezyapp")
  );
}

export default function ApkDetectionWrapper({ children }) {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const isAndroid = /Android/i.test(navigator.userAgent);

    // SHOW POPUP ALWAYS ON ANDROID (except inside APK)
    if (isAndroid && !isInsideApk()) {
      setShowBanner(true);
    }
  }, []);

  const downloadApk = () => {
    window.open("https://cashify.gradezy.in/Cashify.apk", "_blank");
  };

  return (
    <>
      {children}

      {showBanner && (
        <div className="apk-overlay">
          <div className="apk-popup">

            <h3 className="apk-title">Install Our App</h3>

            <p className="apk-text">
              For the best experience, install our Android application.
            </p>

            <div className="apk-buttons">
              <button className="apk-btn-primary" onClick={downloadApk}>
                Download APK
              </button>

              <button
                className="apk-btn-secondary"
                onClick={() => setShowBanner(false)}
              >
                Continue on Web
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}
